import { useSelector } from 'react-redux';
import { selectAllPoints } from '../map/slice/mapSelectors';

// simple component to return a point's name based on ID so we don't have to include all the logic in other components that are otherwise not related
// could be set up to return more info based on props
// TODO: this could be a good place to create a custom field for points that combines data we normally need, like id, name, tsp, etc.  Might be better to do it in the serializer though
export const usePoints = () => useSelector(selectAllPoints);
